import {withFlipFlagProvider} from '@acorn/flip-react-client-sdk';
import {getJWTToken} from '@acorn/mycb-ui-common/lib/catapult';
import PropTypes from 'prop-types';
import React, {useMemo} from 'react';

import {VCF} from '..';

const decodePayload = token => {
  const [jwtPayload] = token.split('.');
  try {
    return JSON.parse(atob(jwtPayload));
  } catch (err) {
    return {};
  }
};

/**
 * Prepares userKey and custom attributes for the input to feature flagging API
 * @param {*} isLoggedIn
 */
const getUserContext = isLoggedIn => {
  const payloadCb = isLoggedIn ? decodePayload(getJWTToken()).cb : {};
  const custom =
    isLoggedIn && payloadCb
      ? {
        userKey: payloadCb.un,
        cohort: payloadCb.dp.cohort,
        gender: payloadCb.dp.gender,
        addressType: payloadCb.dp.address.addressType,
        stateCode: payloadCb.dp.address.stateCode,
        coutryCode: payloadCb.dp.address.countryCode,
        studentSearchServiceOptIn: payloadCb.dp.studentSearchServiceOptIn
      }
      : {};
  return {userKey: isLoggedIn && payloadCb ? payloadCb.un : '', custom};
};

/**
 * Renders feature flip provider with custom data using fields from jwtToken if available.
 * NOTE:  withFlipFlagProvider should be called only once higher up in component hierarchy
 * when all the data needed to set userKey and custom fields is available.
 */
const VCFWrapper = props => {
  const {isLoggedIn, ...restProps} = props;
  const VCFConsumer = useMemo(() => {
    const connectionOptions = {
      baseUrl: process.env.featureFlipClientUrl
    };
    // you can obtain envKey, projectKey from admin flip settings.
    const flipProviderInput = {
      envKey: process.env.featureFlipEnvKey,
      projectKey: process.env.featureFlipProjectKey,
      user,
      connectionOptions
    };
    return withFlipFlagProvider(flipProviderInput)(VCF);
  }, [user]);
  return <VCFConsumer {...restProps} />;
};

VCFWrapper.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired
};

export default VCFWrapper;